<template lang="pug">
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  :items='list'
  item-value='id'
  item-text='state_name'
)
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import picker from '@/mixins/picker'

export default {
  mixins: [picker],

  props: {
    label: {
      default: 'Выберите этап строительства'
    }
  },

  created() {
    this.fetch()
  },

  methods: mapActions('dictionary/objectSteps', ['fetch']),
  computed: mapGetters('dictionary/objectSteps', ['list'])
}
</script>
